import { h } from '@debbie/cortex/dist/index.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import { useUpdateTypes, useUpdateTypesMap, } from '@debbie/cortex/dist/update-types/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Button, ButtonGroup } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const UpdatesGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    const updateTypesLoadable = useUpdateTypes();
    const updateTypes = h.hasData(updateTypesLoadable)
        ? updateTypesLoadable.data
        : null;
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    return (React.createElement(FilterGroup, { name: lang.caseFilter.updatesGroup },
        React.createElement(FilterOption, { active: typeof caseFilter.isPaused === 'boolean', header: lang.caseFilter.caseIsCurrently, onDeactivate: () => caseFilterStore.clearFilter('isPaused') },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.isPaused === true, onClick: (e) => caseFilterStore.updateFilter({
                        isPaused: true,
                    }) }, lang.caseFilter.paused),
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.isPaused === false, onClick: (e) => caseFilterStore.updateFilter({
                        isPaused: false,
                    }) }, lang.caseFilter.notPaused))),
        React.createElement(FilterOption, { active: !!(caseFilter.hasUpdateIds && caseFilter.hasUpdateIds.length), header: lang.caseFilter.hasFollowingStatus, subheader: lang.caseFilter.hasFollowingStatusSub, onDeactivate: () => caseFilterStore.clearFilter('hasUpdateIds') },
            React.createElement(Select, { value: (caseFilter.hasUpdateIds || []).map((updateTypeId) => {
                    const updateType = updateTypesMap[updateTypeId];
                    return {
                        label: lang.updateTypes[updateTypeId] ||
                            (updateType && updateType.label) ||
                            updateType,
                        value: updateTypeId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectStatus, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                    label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                    value: updateType.updateTypeId,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        hasUpdateIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.doNotHaveUpdateIds &&
                caseFilter.doNotHaveUpdateIds.length), header: lang.caseFilter.doNotHaveFollowingStatus, subheader: lang.caseFilter.doNotHaveFollowingStatusSub, onDeactivate: () => caseFilterStore.clearFilter('doNotHaveUpdateIds') },
            React.createElement(Select, { value: (caseFilter.doNotHaveUpdateIds || []).map((updateTypeId) => {
                    const updateType = updateTypesMap[updateTypeId];
                    return {
                        label: lang.updateTypes[updateTypeId] ||
                            (updateType && updateType.label) ||
                            updateType,
                        value: updateTypeId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectStatus, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                    label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                    value: updateType.updateTypeId,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        doNotHaveUpdateIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.hasCurrentPauseIds &&
                caseFilter.hasCurrentPauseIds.length), header: lang.caseFilter.isPausedFollowingStatus, subheader: lang.caseFilter.isPausedFollowingStatusSub, onDeactivate: () => caseFilterStore.clearFilter('hasCurrentPauseIds') },
            React.createElement(Select, { value: (caseFilter.hasCurrentPauseIds || []).map((updateTypeId) => {
                    const updateType = updateTypesMap[updateTypeId];
                    return {
                        label: lang.updateTypes[updateTypeId] ||
                            (updateType && updateType.label) ||
                            updateType,
                        value: updateTypeId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectStatus, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                    label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                    value: updateType.updateTypeId,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        hasCurrentPauseIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.doNotHaveCurrentPauseIds &&
                caseFilter.doNotHaveCurrentPauseIds.length), header: lang.caseFilter.isNotPausedFollowingStatus, subheader: lang.caseFilter.isNotPausedFollowingStatusSub, onDeactivate: () => caseFilterStore.clearFilter('doNotHaveCurrentPauseIds') },
            React.createElement(Select, { value: (caseFilter.doNotHaveCurrentPauseIds || []).map((updateTypeId) => {
                    const updateType = updateTypesMap[updateTypeId];
                    return {
                        label: lang.updateTypes[updateTypeId] ||
                            (updateType && updateType.label) ||
                            updateType,
                        value: updateTypeId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectStatus, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                    label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                    value: updateType.updateTypeId,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        doNotHaveCurrentPauseIds: selected,
                    });
                } }))));
};
export default UpdatesGroup;
//# sourceMappingURL=UpdatesGroup.js.map